module.exports = __webpack_public_path__ + "img/Custom-Skin(1)@2x.1f531a30.jpg";